<script lang="ts">
    export let brightColor = true
    export let edges = true
</script>

<div id="crinkle">
    <div
        class="crinkle-background"
        class:brightColor="{brightColor}"
    >
        <img
            src="../../../media/{edges
                ? brightColor
                    ? ''
                    : 'topRightCrinkledDarkAndEdged'
                : brightColor
                ? 'topRightCrinkleBrightAndUnedged'
                : 'topRightCrinkledDarkAndUnedged'}.svg"
            alt="crinkle"
        />
    </div>
    <div class="action-container">
        <slot />
    </div>
</div>

<style lang="less">
    #crinkle {
        height: calc(3rem - 2px);
        width: 3rem;
        margin-left: -3px;
        .crinkle-background {
            position: relative;
            height: 100%;
            width: 100%;
            overflow: visible;
            img {
                object-fit: cover;
                height: 100%;
                width: 100%;
            }
            &.brightColor {
            }
        }
    }
</style>
